<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="halftitlepage" id="bkht">
<h1 class="bkht"><span aria-label="i" class="page" id="pi" role="doc-pagebreak"></span>Data Analysis in Qualitative Research</h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-timmermans-0002.vue?7c47bc4d